import React, { useState } from "react";
import AdminHeader from "../AdminHeader/AdminHeader";
import SideBarAdmin from "../SideBarAdmin/SideBarAdmin";

import { useDispatch } from "react-redux";
// import PricingAdminFields from "./PricingAdminFields";

const AdminDashBoard = () => {
  const [rightHeader, setRightHeader] = useState(false);

  const dispatch = useDispatch();

  return (
    <>
      <AdminHeader rightHeader={rightHeader} />

      <div className="topSideVehicles">
        <SideBarAdmin
          setRightHeader={setRightHeader}
          rightHeader={rightHeader}
        />
       {/* <PricingAdminFields/> */}
      </div>
    </>
  );
};

export default AdminDashBoard;
